import DataGridTableSkeleton from "../../../../components/skeletons/DataGridTableSkeleton";

export default function MasterDataRequestSkeleton() {
  return (
    <DataGridTableSkeleton height={500} rowCount={10} />
  );
}
